/**
 * Distribution lines data: manufacturers by letter
 */
export const DISTRIBUTION_DATA = {
  manufacturers: [
    { name: "Abel Pumps", letter: "A" },
    { name: "Accurex", letter: "A" },
    { name: "Acopian", letter: "A" },
    { name: "Acromag", letter: "A" },
    { name: "Acme Electric", letter: "A" },
    { name: "AC Valve", letter: "A" },
    { name: "Adalet", letter: "A" },
    { name: "Adams Lithogram", letter: "A" },
    { name: "Advanced Controls", letter: "A" },
    { name: "Advanced Micro Control", letter: "A" },
    { name: "Air Power", letter: "A" },
    { name: "Air Solutions", letter: "A" },
    { name: "Alliance Express", letter: "A" },
    { name: "American Aerospace Controls", letter: "A" },
    { name: "American Casting & Mfg.", letter: "A" },
    { name: "American Industrial Heat Transfer", letter: "A" },
    { name: "Antaira Technologies", letter: "A" },
    { name: "Anver", letter: "A" },
    { name: "Aplus Finetek Sensor", letter: "A" },
    { name: "Applied Robotics", letter: "A" },
    { name: "Armin Hamma Umwelttechnik", letter: "A" },
    { name: "Assured Automation", letter: "A" },
    { name: "AST Sensors", letter: "A" },
    { name: "Athens Paper", letter: "A" },
    { name: "Auburn Systems", letter: "A" },
    { name: "Avtron Encoders", letter: "A" },
    { name: "Axis Fabrication & Machine", letter: "A" },
    { name: "Axiomatic Technologies", letter: "A" },
    { name: "Aya Instruments", letter: "A" },
    { name: "B&B Electronics Mfg", letter: "B" },
    { name: "B-Tec Gunwasher", letter: "B" },
    { name: "Bailey International", letter: "B" },
    { name: "Barber Colman (Eurotherm)", letter: "B" },
    { name: "Baumueller-Nuermont", letter: "B" },
    { name: "Beckhoff Automation", letter: "B" },
    { name: "BEI Technologies", letter: "B" },
    { name: "Belt-Way Scales", letter: "B" },
    { name: "Benshaw", letter: "B" },
    { name: "Bete (VW)", letter: "B" },
    { name: "Beverly Steel", letter: "B" },
    { name: "Bikon Technik", letter: "B" },
    { name: "Bioenno Power", letter: "B" },
    { name: "Bleichert", letter: "B" },
    { name: "Boltswitch", letter: "B" },
    { name: "Bonitron", letter: "B" },
    { name: "Breeding Insulation", letter: "B" },
    { name: "Brook Crompton", letter: "B" },
    { name: "Bromer", letter: "B" },
    { name: "Brother International", letter: "B" },
    { name: "Brumall Manufacturing", letter: "B" },
    { name: "Buhl E.K.", letter: "B" },
    { name: "Bussman Fuses", letter: "B" },
    { name: "C & D Technologies", letter: "C" },
    { name: "Carbide Probes", letter: "C" },
    { name: "Carel", letter: "C" },
    { name: "Carotron", letter: "C" },
    { name: "Carlo Gavazzi", letter: "C" },
    { name: "Chessel", letter: "C" },
    { name: "Chicopee Engineering Associates", letter: "C" },
    { name: "Chromolax", letter: "C" },
    { name: "Cleveland Motion Control", letter: "C" },
    { name: "Cole-Parmer Instrument", letter: "C" },
    { name: "Conductix Wampfler", letter: "C" },
    { name: "Control Tech", letter: "C" },
    { name: "Conveyor Components", letter: "C" },
    { name: "C R Magnetics", letter: "C" },
    { name: "Cutris-Toledo Compressors", letter: "C" },
    { name: "Cytec Systems UK", letter: "C" },
    { name: "Darrah Electric", letter: "D" },
    { name: "Datex Instruments", letter: "D" },
    { name: "Debem s.r.l.", letter: "D" },
    { name: "Dentmagic Tools", letter: "D" },
    { name: "Devar", letter: "D" },
    { name: "Ditek", letter: "D" },
    { name: "Dosatron International", letter: "D" },
    { name: "Dynisco", letter: "D" },
    { name: "Dimetix", letter: "D" },
    { name: "DIS Sensors USA", letter: "D" },
    { name: "Ebro Armaturen USA", letter: "E" },
    { name: "Eccentric Pumps", letter: "E" },
    { name: "Econo Lift", letter: "E" },
    { name: "Ekstrom Carlson", letter: "E" },
    { name: "Electro-Mec", letter: "E" },
    { name: "Electro-Sensors", letter: "E" },
    { name: "Elliott Industries", letter: "E" },
    { name: "Elpro Technologies PTY", letter: "E" },
    { name: "Elsta-Mosdorfer Gesellschaft", letter: "E" },
    { name: "Emedco", letter: "E" },
    { name: "Emotron", letter: "E" },
    { name: "Equalizer", letter: "E" },
    { name: "Erdco Engineering", letter: "E" },
    { name: "Eriez Manufacturing", letter: "E" },
    { name: "Ernst Flow Insutries", letter: "E" },
    { name: "Exair", letter: "E" },
    { name: "Excalibur", letter: "E" },
    { name: "Ex Industries", letter: "E" },
    { name: "Exotherm", letter: "E" },
    { name: "Fanuc", letter: "F" },
    { name: "Ferguson", letter: "F" },
    { name: "Fersco Saws", letter: "F" },
    { name: "Fibox", letter: "F" },
    { name: "Finder", letter: "F" },
    { name: "Flexicon", letter: "F" },
    { name: "Fluid-O-Tech", letter: "F" },
    { name: "FMC Technologies", letter: "F" },
    { name: "Fori Automation", letter: "F" },
    { name: "Fostoria Bushings & Insulators", letter: "F" },
    { name: "Future Design Controls", letter: "F" },
    { name: "Gaylord Manufacturing", letter: "G" },
    { name: "Gerdau Ameristeel", letter: "G" },
    { name: "Global Insutrial", letter: "G" },
    { name: "Gordon Products", letter: "G" },
    { name: "Grace Engineered Products", letter: "G" },
    { name: "Grenzenbach", letter: "G" },
    { name: "Heat and Sensors", letter: "H" },
    { name: "Hebotec", letter: "H" },
    { name: "Helukabel", letter: "H" },
    { name: "Helm Instrument", letter: "H" },
    { name: "Hilscher North America", letter: "H" },
    { name: "Hioki USA", letter: "H" },
    { name: "Hohner", letter: "H" },
    { name: "Honeywell Sensing & Control", letter: "H" },
    { name: "HTM Electronics", letter: "H" },
    { name: "Icotek", letter: "I" },
    { name: "Idec", letter: "I" },
    { name: "Idezi ID", letter: "I" },
    { name: "IFM Effector", letter: "I" },
    { name: "Igus", letter: "I" },
    { name: "IKO Instruments", letter: "I" },
    { name: "Indoff", letter: "I" },
    { name: "Indusol", letter: "I" },
    { name: "Industrial Magnetics", letter: "I" },
    { name: "Infrared & Chrome", letter: "I" },
    { name: "Ingun", letter: "I" },
    { name: "Inspired Energy", letter: "I" },
    { name: "Instrucon", letter: "I" },
    { name: "Interstate Plastics", letter: "I" },
    { name: "Ipotec", letter: "I" },
    { name: "Jameco Electronics", letter: "J" },
    { name: "John Ellsworth", letter: "J" },
    { name: "Joslyn Clark", letter: "J" },
    { name: "Jumo", letter: "J" },
    { name: "Karl Dungs", letter: "K" },
    { name: "KB", letter: "K" },
    { name: "Kele", letter: "K" },
    { name: "Keyence", letter: "K" },
    { name: "Kinetics Industries", letter: "K" },
    { name: "Klockner Moeller", letter: "K" },
    { name: "Knoll America", letter: "K" },
    { name: "Kracht", letter: "K" },
    { name: "KSB", letter: "K" },
    { name: "KTR", letter: "K" },
    { name: "L-Com", letter: "L" },
    { name: "Laird Controls North America", letter: "L" },
    { name: "Lantronix", letter: "L" },
    { name: "Lapp", letter: "L" },
    { name: "Lawson Products", letter: "L" },
    { name: "LDPI", letter: "L" },
    { name: "Lecorp", letter: "L" },
    { name: "Lee Spring", letter: "L" },
    { name: "Lenze", letter: "L" },
    { name: "Lewco", letter: "L" },
    { name: "Linemaster Switch", letter: "L" },
    { name: "Lion Precision", letter: "L" },
    { name: "Little Fuse", letter: "L" },
    { name: "LMB Kunstsofftechnik", letter: "L" },
    { name: "Lodar Service", letter: "L" },
    { name: "Lucas Industrial", letter: "L" },
    { name: "Lumentec", letter: "L" },
    { name: "Lutze", letter: "L" },
    { name: "Maple Systems", letter: "M" },
    { name: "Marathon Special Products", letter: "M" },
    { name: "Mason", letter: "M" },
    { name: "Masterlock", letter: "M" },
    { name: "Mcmaster Carr", letter: "M" },
    { name: "MCS Engravers", letter: "M" },
    { name: "Meeco", letter: "M" },
    { name: "Mercury Engraving", letter: "M" },
    { name: "Metrix Electronic Ltd.", letter: "M" },
    { name: "MF Power Resistor Ltd.", letter: "M" },
    { name: "Micro Epsilon", letter: "M" },
    { name: "Midland Metal Mfg.", letter: "M" },
    { name: "Minarik", letter: "M" },
    { name: "Moeller", letter: "M" },
    { name: "Mor Electric Heating Assoc.", letter: "M" },
    { name: "MPI Morheat", letter: "M" },
    { name: "Multi-Contact USA", letter: "M" },
    { name: "Murr Plastik", letter: "M" },
    { name: "Nalco", letter: "N" },
    { name: "Namco", letter: "N" },
    { name: "Niedax", letter: "N" },
    { name: "NK Technologies", letter: "N" },
    { name: "Nocturnal Lights", letter: "N" },
    { name: "Nord Drive Systems", letter: "N" },
    { name: "Norfi Absaugtechnik GmbH (Germany / VW)", letter: "N" },
    { name: "Norman Lamps", letter: "N" },
    { name: "Northern Tool", letter: "N" },
    { name: "Novotechnik", letter: "N" },
    { name: "NSI Industries", letter: "N" },
    { name: "O'Neal Steel", letter: "O" },
    { name: "Orr & Associates", letter: "O" },
    { name: "Oshino Lamps America", letter: "O" },
    { name: "Overly Hautz", letter: "O" },
    { name: "Ozone Solutions", letter: "O" },
    { name: "P&P Engraving", letter: "P" },
    { name: "P3 America", letter: "P" },
    { name: "Palmer Instruments", letter: "P" },
    { name: "Panef (VW)", letter: "P" },
    { name: "Payne Engineering", letter: "P" },
    { name: "Pearl", letter: "P" },
    { name: "Peerless Industries", letter: "P" },
    { name: "Pegasus Lighting", letter: "P" },
    { name: "Pepperl+Fuchs Process Automation", letter: "P" },
    { name: "Pepperl+Fuchs Factory Automation", letter: "P" },
    { name: "Pfanneburg", letter: "P" },
    { name: "Phase-A-Matic", letter: "P" },
    { name: "Pilz", letter: "P" },
    { name: "Plastic Dip Moldings", letter: "P" },
    { name: "Point Grey", letter: "P" },
    { name: "Polytec", letter: "P" },
    { name: "Post Glover Resistors", letter: "P" },
    { name: "Potdevin Machine", letter: "P" },
    { name: "Powertek US", letter: "P" },
    { name: "Powerhouse Controls", letter: "P" },
    { name: "Power Survey Capacitors & Harmonic Filters", letter: "P" },
    { name: "Primax Technologies", letter: "P" },
    { name: "Protego USA", letter: "P" },
    { name: "Protech Metak Finishing", letter: "P" },
    { name: "Puls", letter: "P" },
    { name: "Qmark (VW)", letter: "Q" },
    { name: "Raycap", letter: "R" },
    { name: "RCI Custom Products", letter: "R" },
    { name: "RedLion", letter: "R" },
    { name: "Refu Elektronik GmbH (Germany)", letter: "R" },
    { name: "Remke", letter: "R" },
    { name: "Resa Power Solutions", letter: "R" },
    { name: "Reuland Electric", letter: "R" },
    { name: "Rhino (VW)", letter: "R" },
    { name: "Rollon", letter: "R" },
    { name: "Ross Valve", letter: "R" },
    { name: "S&C Electric", letter: "S" },
    { name: "SAB", letter: "S" },
    { name: "Saginaw Controls", letter: "S" },
    { name: "Saint Machinery", letter: "S" },
    { name: "Salzer", letter: "S" },
    { name: "Schaeffers Electrical Enclosures", letter: "S" },
    { name: "Schmalz", letter: "S" },
    { name: "Schubert & Salzer", letter: "S" },
    { name: "Scitronics Industrial Systems", letter: "S" },
    { name: "SSAC", letter: "S" },
    { name: "Seko Dosing Systems", letter: "S" },
    { name: "Sentran", letter: "S" },
    { name: "Seton", letter: "S" },
    { name: "SFI America", letter: "S" },
    { name: "Signaworks", letter: "S" },
    { name: "Simco Ion", letter: "S" },
    { name: "Sisken Steel", letter: "S" },
    { name: "Smart Sensors", letter: "S" },
    { name: "Softing", letter: "S" },
    { name: "Solar Pro's", letter: "S" },
    { name: "Solmon", letter: "S" },
    { name: "Sonic Air Systems", letter: "S" },
    { name: "Southeastern Tool & Design", letter: "S" },
    { name: "Springer Controls", letter: "S" },
    { name: "Start International", letter: "S" },
    { name: "States Electric", letter: "S" },
    { name: "Staubli", letter: "S" },
    { name: "Sterling Power USA", letter: "S" },
    { name: "Steute Xtreme", letter: "S" },
    { name: "Storage Battery Systems", letter: "S" },
    { name: "Stoem Power Components", letter: "S" },
    { name: "Sunnex Mounts", letter: "S" },
    { name: "Symcom", letter: "S" },
    { name: "Syntron", letter: "S" },
    { name: "TCI", letter: "T" },
    { name: "TCP Global", letter: "T" },
    { name: "Techtop – Motors", letter: "T" },
    { name: "Tecsis", letter: "T" },
    { name: "Tek-Temp Instruments", letter: "T" },
    { name: "Tempco", letter: "T" },
    { name: "Tencarva", letter: "T" },
    { name: "Tessco", letter: "T" },
    { name: "Thermcraft", letter: "T" },
    { name: "Topworx", letter: "T" },
    { name: "Totalcomp Scales & Components", letter: "T" },
    { name: "TR Electronics", letter: "T" },
    { name: "Transcat", letter: "T" },
    { name: "Trastar", letter: "T" },
    { name: "Transducer Techniques", letter: "T" },
    { name: "Tri Lite", letter: "T" },
    { name: "Tunkers", letter: "T" },
    { name: "Turk & Hillinger", letter: "T" },
    { name: "Tyco Electronics", letter: "T" },
    { name: "Ultrachem", letter: "U" },
    { name: "Vacon", letter: "V" },
    { name: "Vaisala", letter: "V" },
    { name: "VanTran", letter: "V" },
    { name: "Versitron", letter: "V" },
    { name: "Veris Industries", letter: "V" },
    { name: "Vibco", letter: "V" },
    { name: "Vipa", letter: "V" },
    { name: "Voigt Abernathy (W)", letter: "V" },
    { name: "Volkin Electronics", letter: "V" },
    { name: "Volunteer Wire & Rope", letter: "V" },
    { name: "Vortec", letter: "V" },
    { name: "VPI Instruments", letter: "V" },
    { name: "Walther Flender", letter: "V" },
    { name: "Warren Electric", letter: "V" },
    { name: "Weber Sensors", letter: "V" },
    { name: "Wago", letter: "W" },
    { name: "Weg", letter: "W" },
    { name: "Weishaupt (VW)", letter: "W" },
    { name: "Wenglor", letter: "W" },
    { name: "Worksman", letter: "W" },
    { name: "Yaskawa", letter: "Y" },
    { name: "Yokogawa", letter: "Y" },
    { name: "Zerust", letter: "Z" },
  ],
};
